import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import connectApp from './ConnectedApp';
import createStore from '../setup/store';
import createApolloClient from '../setup/apollo';
import Switcher from '../../routing/components/Switcher';
import { actions as routingActions } from '../../routing/store/Pages/actions';
import useReduxSnackbar from '../../hooks/useReduxSnackbar';

const RoutedAppContent = props => {
  useReduxSnackbar(); // probably not the best place to sit this, but it was the highest level possible
  const { store } = props;
  const state = store.getState();
  const { pages } = state;
  store.dispatch(routingActions.pageWasReloaded(pages));
  window.dataLayer.push({
    user_id: _.get(state, 'user.userProfile.id'),
    company: _.chain(state)
      .get('user.userProfile.email')
      .split('@')
      .get(1)
      .value(),
    tenant: _.get(state, 'company.subdomain'),
  });
  return <Switcher />;
};

RoutedAppContent.propTypes = {
  store: PropTypes.objectOf(PropTypes.any).isRequired,
};

const RoutedApp = connectApp(createStore, createApolloClient, RoutedAppContent);

export default RoutedApp;
